import parseMarkdownToHtml from '@sdk/components/richText/helpers/parseMarkdownToHtml';

export default function RenderContent(Authentication, PersonaCollection, UserUtils, Utils, $sce) {
  'ngInject';

  const service = this;
  service.get = function get(rawContent, parseMentions) {
    const parsed = parseMarkdownToHtml(rawContent, {
      parseMentions,
      currentUser: Authentication.user,
      canEditGroup: (group) => UserUtils.canEditGroup(group),
      hasAccessToUser: PersonaCollection.hasAccessToUser,
      personasDict: PersonaCollection.personasDict,
    });

    return $sce.trustAsHtml(`<span class="rendered-content">${parsed}</span>`);
  };
}
